export const state = {
  missionnaire: undefined,
  missionnaires: [],
  pagination: { size: 25 },
  filter: {
    query: "",
  },
};